import React from "react";

const Bash_Arrays = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Arrays</h2>
    </div>
  );
};

export default Bash_Arrays;
